import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';
import type { CardRenderItem } from '../cardRenderItemGenerator';

export const useLogDisplayCardItems = () => {
  const displayLoggedList = useRef<number[]>([]);

  // bridge 직접 호출 대신 AnalyticsContext 자동 머지 wrapper 사용.
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logDisplayCardItems = useCallback<
    NonNullable<FlatListProps<CardRenderItem>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ index, isViewable, item }) => {
        if (index === null || !isViewable) {
          return;
        }
        if (displayLoggedList.current.includes(index)) {
          return;
        }
        displayLoggedList.current.push(index);

        if (item.type === 'PRIMARY_CARD') {
          logAnalyticsEvent({
            name: 'DISPLAY_PRIMARY_CARD',
            analytics: item.logging.analytics,
            ably_only_log: item.logging.ably_only_log,
          });
        } else if (item.type === 'VIDEO_GOODS_CARD' || item.type === 'FULL_VIDEO_GOODS_CARD') {
          logAnalyticsEvent({
            name: 'DISPLAY_GOODS',
            analytics: { CARD_TYPE: 'VIDEO', ...item.logging.analytics },
            ably_only_log: item.logging.ably_only_log,
          });
          if (isNotNil(item.item.ad)) {
            bridge.logAdEvent({
              action: AdAction.DISPLAY,
              ad: item.item.ad,
            });
          }
        } else {
          logAnalyticsEvent({
            name: 'DISPLAY_GOODS',
            analytics: item.logging.analytics,
            ably_only_log: item.logging.ably_only_log,
          });
          if (isNotNil(item.item.ad)) {
            bridge.logAdEvent({
              action: AdAction.DISPLAY,
              ad: item.item.ad,
            });
          }
        }
      });
    },
    [logAnalyticsEvent],
  );

  return { logDisplayCardItems };
};
